<template>
  <v-container>
    <!-- <div v-if="alerta">
        <alert-empty></alert-empty>
      </div> -->
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Ejecucion de Retorno</v-toolbar-title
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <grid-ejecucion
          :key="ejecucionGrid"
          :contratoId="contratoId"
        ></grid-ejecucion>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GridEjecucion from "./GridEjecucion.vue";

export default {
  name: "visita-sub-tab",

  components: {
    GridEjecucion,
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      ejecucionGrid: 0,
      alerta: false,
    };
  },
  computed: {},
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
    }
  },
  methods: {
    reloadEjecucion() {
      this.ejecucionGrid += 1;
    },
  },
};
</script>
